module.exports = __webpack_public_path__ + "static/pocketbits-bw-b67984f4aac2a92ea0b10e679e427cae.jpg";